import { Controller, useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { DefaultPillInput } from '@/_components/default-pill-input/default-pill-input';
import styles from './fare-map.module.scss';
import type { AddressManipulationProps, TypeFranchiseForm } from '../../types';
import MapWithPin from '@/Components/map-with-pin/MapWithPin';
import { isValidLatOrLong } from '@/Utils/FnUtils';

interface FareMapProps {
  addressManipulationProps?: AddressManipulationProps;
}

export const FareMap = ({ addressManipulationProps }: FareMapProps) => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<TypeFranchiseForm>();

  const { onAddressChange, address, isLoadingAddress, addressLocation } =
    addressManipulationProps || {};

  const location = watch('localizacao');

  const zoom = useMemo(() => {
    if (addressLocation) {
      return 14.5;
    }

    return 5;
  }, [addressLocation]);

  const isLoadingMap =
    isLoadingAddress ||
    !isValidLatOrLong(location?.latitude || 0) ||
    !isValidLatOrLong(location?.longitude || 0);

  return (
    <div className={styles.container}>
      <DefaultPillInput
        containerClassName={styles.addressContainer}
        inputWrapperClassName={styles.addressInputWrapper}
        value={address}
        onChange={event => onAddressChange?.(event.target.value)}
        label="Endereço"
      />

      <div className={styles.inputsContainer}>
        <Controller
          control={control}
          name="localizacao.latitude"
          render={({ field }) => (
            <DefaultPillInput
              containerClassName={styles.mobilePillInputContainer}
              required
              {...field}
              label="Latitude"
            />
          )}
        />
        <Controller
          control={control}
          name="localizacao.longitude"
          render={({ field }) => (
            <DefaultPillInput
              containerClassName={styles.mobilePillInputContainer}
              required
              {...field}
              label="Longitude"
            />
          )}
        />
        <Controller
          control={control}
          name="codigoIbge"
          render={({ field }) => (
            <DefaultPillInput
              containerClassName={styles.mobilePillInputContainer}
              {...field}
              label="Código IBGE"
              errorMessage={errors.codigoIbge?.message}
              error={!!errors.codigoIbge?.message}
            />
          )}
        />
      </div>

      <div className={styles.mapContainer}>
        <MapWithPin
          loadingMap={isLoadingMap}
          onChangePin={position => {
            setValue(
              'localizacao.latitude',
              Number(position.lat.toPrecision(9)),
              { shouldDirty: true },
            );
            setValue(
              'localizacao.longitude',
              Number(position.lng.toPrecision(9)),
              { shouldDirty: true },
            );
          }}
          popupLabel="Local central da cidade"
          zoom={zoom}
          mainPosition={{
            latitude: location?.latitude || 0,
            longitude: location?.longitude || 0,
          }}
        />
      </div>
    </div>
  );
};
